import { Button } from '../../Components/UI/button';
import CountdownTimer from '../../Components/Common/CountDownTimer';
import { getAt99 } from '../../Utils/Utilities';

const SahiPricingFooter = () => {
    if (!getAt99) return null;
    // Set flash offer expiry date (e.g., 24 hours from now)
    const getFlashOfferExpiry = () => {
        const now = new Date();
        const expiryTime = new Date(now.getTime() + 24 * 60 * 60 * 1000000); // 24 hours
        return expiryTime.toISOString();
    };

    const handleBuyNow = () => {
        scrollToSection('pkgAndPricing');
    };

	const scrollToSection = (sectionId) => {
		const element = document.getElementById(sectionId);
		if (element) {
			element.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	};

    return (
        <div 
            className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white  px-3 py-3 shadow-[0_0_20px_rgba(0,0,0,0.2)] cursor-pointer"
            onClick={handleBuyNow}
        >
            <div className="flex items-center justify-between gap-3">
                {/* Left Side - Pricing Info */}
                <div className="flex flex-col gap-0 flex-1">
                    <p className="text-sahi-green text-sm font-semibold">Start First Year @ just</p>
                    <div className="flex items-baseline gap-1">
                        <span className="text-lg text-gray-500">₹</span>
                        <span className="-translate-x-0.5 text-2xl font-bold text-gray-800">99</span>
                        <span className="text-md text-gray-500 line-through">1,200</span>
                        <span className="text-xs text-gray-500 line-through">/ year</span>
                        <p className="text-xs text-gray-600">+GST</p>
                    </div>
                    {/* <div className="mt-0.5">
                        <CountdownTimer
                            showFlash={true}
                            size="sm"
                            className="text-red-500 text-sm"
                            text={"Flash Offer Ends Soon!"}
                        />
                    </div> */}
                </div>

                {/* Right Side - Buy Now Button */}
                <Button
                    onClick={handleBuyNow}
                    className="bg-sahi-green text-white font-medium px-2 py-2 rounded-md transition-colors whitespace-nowrap text-sm"
                >
                    Buy Now
                </Button>
            </div>
        </div>
    );
};

export default SahiPricingFooter;
